import { render, staticRenderFns } from "./certificateQuery.vue?vue&type=template&id=3a0bf367&scoped=true&"
import script from "./certificateQuery.vue?vue&type=script&lang=js&"
export * from "./certificateQuery.vue?vue&type=script&lang=js&"
import style0 from "./certificateQuery.vue?vue&type=style&index=0&id=3a0bf367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0bf367",
  null
  
)

export default component.exports